import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Modal, Picker, Toast } from 'antd-mobile';
import Icon, {
  PhoneOutlined,
  CopyOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import { WebviewHttpHandler } from 'shared/webviewHttpHandler';
import { CryptoHandler } from 'shared/cryptoHandler';
import CustomSkeleton from 'pages/mobile/car/ContactSkeleton';
import secureStorage from 'shared/secureStorage';

const webviewHttpHandler = new WebviewHttpHandler(true);
const cryptoHandler = new CryptoHandler();

const SalesInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { plateNumber } = location.state;
  const [sales, setSales] = useState({
    name: '',
    phone: '',
    mail: '',
    line: '',
  });
  const [loading, setLoading] = useState(true);
  // 取得業代資訊
  const getSalesInfo = () => {
    webviewHttpHandler
      .get(
        `/service/member/sales?line=${secureStorage.getItem(
          'lineUserId'
        )}&category=1&carno=${plateNumber}`
      )
      .then((res) => {
        if (res.success) {
          // 解密人名、手機
          setSales({
            name: cryptoHandler.decrypt(res.data.name),
            phone: cryptoHandler.decrypt(res.data.phone),
            mail: res.data.mail,
            line: res.data.line,
          });
          setLoading(false);
        } else {
          console.error(res);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // 复制电子邮件到剪贴板的函数
  const handleCopyMail = (mail) => {
    navigator.clipboard
      .writeText(mail)
      .then(() => {
        // 复制成功后显示Toast提示
        Toast.show({
          content: '已複製',
          icon: <CopyOutlined />,
          duration: 1000, // 持续时间，1000毫秒 = 1秒
        });
      })
      .catch((err) => {
        // 处理可能的复制失败情况
        console.error('複製失败', err);
      });
  };
  useEffect(() => {
    getSalesInfo();
  }, []);
  return (
    <>
      <div className="bill-container">
        <div className="heading font-bold ml-3">洽詢租賃業務代理</div>
        <div className="appointment-container ">
          {loading ? (
            <CustomSkeleton />
          ) : (
            <>
              <div className="text-align-center my-6">
                <img
                  className="mb-2"
                  src="/images/illustration/sales-avatar.svg"
                  alt="Description"
                />
                <div className="subheading font-semibold">{sales.name}</div>
              </div>
              <div className="text-body font-normal">
                <div className="my-4">
                  <div className="mb-1">聯絡電話</div>
                  <a
                    href={`tel:+886${sales.phone
                      .substring(1)
                      .replace(/-/g, '')}`}
                    className="red space-between"
                    style={{ textDecoration: 'none' }}>
                    <div>{sales.phone}</div>
                    <PhoneOutlined
                      style={{ fontSize: '20px', color: 'currentColor' }}
                    />
                  </a>
                </div>
                <hr></hr>
                <div className="my-4">
                  <div className="mb-1">線上聊天室</div>
                  <div
                    className="red space-between"
                    onClick={() =>
                      navigate(`/m/Chat`, { state: { plateNumber } })
                    }
                    style={{ cursor: 'pointer' }}>
                    <div>前往聊天室</div>
                    <MessageOutlined
                      style={{ fontSize: '20px' }}></MessageOutlined>
                  </div>
                </div>
                <hr></hr>
                <div className="my-4">
                  <div className="mb-1">電子郵件</div>
                  <div
                    className="red space-between"
                    onClick={() => handleCopyMail(sales.mail)}
                    style={{ cursor: 'pointer' }}>
                    <div>{sales.mail}</div>
                    <CopyOutlined style={{ fontSize: '20px' }} />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SalesInfo;
